import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SubmitAdminFeedbackMutationVariables = Types.Exact<{
  path: Types.Scalars['String'];
  comment: Types.Scalars['String'];
}>;


export type SubmitAdminFeedbackMutation = { __typename?: 'Mutation', submitAdminFeedback: boolean };


export const SubmitAdminFeedbackDocument = gql`
    mutation SubmitAdminFeedback($path: String!, $comment: String!) {
  submitAdminFeedback(path: $path, comment: $comment)
}
    `;
export type SubmitAdminFeedbackMutationFn = Apollo.MutationFunction<SubmitAdminFeedbackMutation, SubmitAdminFeedbackMutationVariables>;

/**
 * __useSubmitAdminFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitAdminFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitAdminFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitAdminFeedbackMutation, { data, loading, error }] = useSubmitAdminFeedbackMutation({
 *   variables: {
 *      path: // value for 'path'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useSubmitAdminFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SubmitAdminFeedbackMutation, SubmitAdminFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitAdminFeedbackMutation, SubmitAdminFeedbackMutationVariables>(SubmitAdminFeedbackDocument, options);
      }
export type SubmitAdminFeedbackMutationHookResult = ReturnType<typeof useSubmitAdminFeedbackMutation>;
export type SubmitAdminFeedbackMutationResult = Apollo.MutationResult<SubmitAdminFeedbackMutation>;
export type SubmitAdminFeedbackMutationOptions = Apollo.BaseMutationOptions<SubmitAdminFeedbackMutation, SubmitAdminFeedbackMutationVariables>;